<template>
  <div>
    <b-card>
      <template #header>
        <h4 class="m-0">Logs</h4>
      </template>
      <ApiLogFilter class="mb-3" @search="setFilter" :loading="loading"/>

      <ApiLogListTable
        :items="items"
        :is-busy="loading"
        :total-rows="listCount"
        :current-page="currentPage"
        :per-page="perPage"
        @page-changed="handlePageChange"
      />
    </b-card>
  </div>
</template>

<script>
import AppNoData from "@/components/app/AppNoData"
import { cloneDeep } from "lodash"
import { getLogList } from "@/services/log"
import ApplicantListTable from "@/components/applicant/list/ApplicantListTable.vue";
import ApiLogListTable from "@/components/logs/list/ApiLogListTable.vue";
import ApiLogFilter from "@/components/logs/list/ApiLogFilter.vue";

export default {
  name: "Index",
  components: {ApiLogFilter, ApiLogListTable, ApplicantListTable, AppNoData },

  data() {
    return {
      loading: false,
      items: [],
      filter: {},
      currentPage: 1,
      perPage: 10,
      listCount: 0,
    }
  },

  watch: {
    currentPage() {
      this.fetchLogs()
    },
    perPage() {
      this.currentPage = 1
      this.fetchLogs()
    },
  },
  mounted() {
    this.fetchLogs()
  },

  methods: {
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchLogs();
    },
    setFilter(values) {
      this.filter = cloneDeep(values)
      this.currentPage = 1
      this.fetchLogs()
    },

    toggleBusy(val) {
      this.loading = val
    },

    async fetchLogs() {
      this.toggleBusy(true);

      try {
        const res = await getLogList({
          page: this.currentPage,
          limit: this.perPage,
          ...this.filter,
        });
        if (res && res.data) {
          this.items = res.data.items || [];

          this.listCount = res.data.total || this.items.length;
        } else {
          this.items = [];
          this.listCount = 0;
        }
      } catch (e) {
        console.error("Greška pri dohvatanju logova:", e);
        this.items = [];
        this.listCount = 0;
      } finally {
        this.toggleBusy(false);
      }
    },
  },

}
</script>


